import React from 'react'

const NoPage = () => {
  return (
    <div>
      page you looking for is not found brr 
    </div>
  )
}

export default NoPage
